<template>
  <div vif="publication" class="body-1 ml-3 " >
    <app-authors-title  v-if="publication" :title="publication.title" :url="publication.url" :authors="publication.authors"></app-authors-title>
    <app-basic-publication  v-if="publication && publication.type<6" :type="publication.type"
        :year="publication.year" :object_type="publication.generaltable" class="ma-0">
    </app-basic-publication>
    <app-preprint v-if="publication && publication.type == 6" :preprint="publication" ></app-preprint>
    <app-thesis v-if="publication && publication.type==7" :supervisors="publication.supervisors" :object_type="publication.generaltable"></app-thesis>
    <app-lecture v-if="publication && publication.type == 8" :lecture="publication" ></app-lecture>
    <p v-if="publication && publication.grants_list && publication.grants_list.length " class="text-caption indigo--text text--darken-2 px-0 pt-0 pb-0 ml=n1 my-0">
     Grant(s):
     <span  v-for="(grant,index) in publication.grants_list" :key="grant.id">
        <router-link :to="{name:'infos',params:{id:grant.id}}" class=" indigo--text text--darken-2 pointer font-weight-medium my-0 py-0" >
            <span v-if="index >0" class="ml-n1">, </span>{{ grant.number }}
        </router-link>
    </span>
    </p>
    <p v-if="bo && publication.type < 6" class="pa-0 ma-0" >
        <v-btn v-if="namePath == 'asep.status.bo'" :color = "btncolor(publication.asep)"
            :class="[publication.asep ==0 ? 'white--text' : 'black--text','font-weight-bold']"
            x-small @click="toggleDown =!toggleDown">
            View
        </v-btn>
        <v-btn v-else outlined :color = "btncolor(publication.asep)" x-small @click="getAsep(publication.asep)">
            <span class="font-weight-bold" >ASEP</span>
        </v-btn>
        <!-- view  -->
        <img v-if="toggleDown"  src="../../../assets/research/up.png" class="pa-1 " @click="toggleDown =!toggleDown">
        <v-card v-if="toggleDown" class="mx-1 mt-0 mb-2 py-0 yellow lighten-3" min-width = "90%" elevation="2">
            <v-row v-if="toggleDown" class="mx-1 my-0 py-O yellow lighten-3">
                <v-col cols="12"  class="pa-0 ml-0" >
                   <view-asep :publication="publication" class="mb-2"></view-asep>
                   <v-btn  color="green"  x-small @click="editAsepData(publication.asep,publication.type,publication.id)">Edit</v-btn>
                </v-col>
            </v-row>
        </v-card>
        <v-btn v-if="namePath == 'asep.status.bo'" outlined  x-small @click="editStatusAsep(publication)">
            <span class="font-weight-bold" >EDIT ASEP STATUS</span>
        </v-btn>
    </p>
</div>
</template>
<script>
import {mapGetters} from 'vuex';
import router from '../../../router';
import basicPublications from './BasicPublications.vue';
import preprint from './preprints/PreprintContent.vue';
import thesis from './thesis/ThesisContent.vue';
import lecture from './lectures/LectureContent.vue';
import authorsTitle from './AuthorsTitle.vue';
import viewAsep from '../../bo/research/publications/ASEP/ViewAsep.vue';

export default {
    props:['publication','bo'],
    data(){
        return{
            toggleDown:false,
            editStausAsep:false,
        }
    },
    components:{
        AppBasicPublication:basicPublications,
        AppPreprint:preprint,
        AppThesis:thesis,
        AppLecture:lecture,
        AppAuthorsTitle:authorsTitle,
        ViewAsep:viewAsep,
    },
    computed:{
        ...mapGetters('formpublication',{
            namePath:'namePath',
            }),
    },
    methods:{
        btncolor(asep){
            if(asep == 2){
                return 'red darken-4'
            }
            else if(asep == 3){
                return 'grey'
            }
            else if(asep == 1){
                return 'success'
            }
            else{
                return 'black';
            }
        },
        getAsep(asep){
            //asep 0=empty,1=submitted,2=registered,3= register directly (old publications)
            // if(asep > 1){
                this.toggleDown = true;
            // }
            // else{
            //     router.push({name:'asep.form',params: {asep:this.publication.asep, type: this.publication.type, id:this.publication.id}});

            // }
        },
        editStatusAsep(publication){
            router.push({name:'asep.edit',params: {asep:this.publication.asep, type: this.publication.type, id:this.publication.id}});
        },
        editAsepData(pub_asep,pub_type,pub_id){
            router.push({ name:'asep.form',params:{asep:pub_asep,type:pub_type,id:pub_id}});
        }
    },
}
</script>




